module.exports = __webpack_public_path__ + "img/1-dhw.d265e39a.png";